import {FunctionComponent} from 'react';
import styles from './stars.module.scss';
import {classNames} from '../../../support/classnames.ts';

interface OwnProps {
    rating?: number | string;
}

export const Stars: FunctionComponent<OwnProps> = ({rating}) => {
    if (typeof rating === 'string') {
        rating = parseInt(rating, 10) ?? 0;
    }

    if (!rating) {
        return (
            <div className={styles.stars}>
                {[0, 1, 2, 3, 4].map((i) => (
                    <span className={classNames(styles.star, styles.empty)} key={i} />
                ))}
            </div>
        );
    }

    const normalizedRating = Math.min(Math.ceil(rating) / 2, 5); // Rating 0 - 100 so this gives 0 - 5 with step .5
    const numberOfFullStars = Math.floor(normalizedRating);
    const numberOfEmptyStars = Math.floor(5 - normalizedRating);
    const showHalfStar = numberOfFullStars + numberOfEmptyStars < 5;

    const stars = [];
    for (let i = 0; i < numberOfFullStars; i++) {
        stars.push(<span className={styles.star} key={`full-${i}`} />);
    }

    if (showHalfStar) {
        stars.push(<span className={classNames(styles.star, styles.half)} key="half" />);
    }

    for (let i = 0; i < numberOfEmptyStars; i++) {
        stars.push(<span className={classNames(styles.star, styles.empty)} key={`empty-${i}`} />);
    }

    return (
        <div className={styles.stars}>
            {stars} <small>{rating}</small>
        </div>
    );
};
